console.log('NIP Validator loaded');

document.addEventListener('DOMContentLoaded', function() {
  async function isAssignedNip(nip) {
    // TO TESTS
    // const mockNip = 'PL8133718060';
    // const mockUrl = `https://arstattoo-api.sintraconsulting.pl/api/nip/PL8133718060`;

    const validator_url = `${window.Eurus.validator_url}/${nip}`;

    try {
      const response = await fetch(validator_url, {
        method: "GET",
      });

      if (!response.ok) {
        return true;
      }

      const data = await response.json();

      return data.is_assigned;
    } catch (error) {
      return true;
    }
  }

  const isInputHidden = (input) => {
    const fieldContainer = input.closest('.bss-b2b-rf-field');
    return fieldContainer && fieldContainer.hasAttribute('bss-b2b-rf-conditional-logic-hide');
  };

  const findNipInput = () => {
    const form = document.querySelector('#bss-b2b-register-form');
    if (!form) return null;

    // Try to find by label text containing "NIP"
    const labels = form.querySelectorAll('label.label-field');
    for (const label of labels) {
      if (label.textContent.includes('NIP')) {
        const labelFor = label.getAttribute('for');
        if (labelFor) {
          const input = form.querySelector(`#${labelFor}`);
          if (input && !isInputHidden(input)) return input;
        }
      }
    }

    // Try to find by placeholder containing "NIP"
    const inputByPlaceholder = form.querySelector('input[placeholder*="NIP"]');
    if (inputByPlaceholder && !isInputHidden(inputByPlaceholder)) return inputByPlaceholder;

    // Fallback to vat-validation (Germany)
    const vatInput = form.querySelector('input[name="vat-validation"]');
    if (vatInput && !isInputHidden(vatInput)) return vatInput;

    return null;
  };

  const enforceUppercaseOnInput = (input) => {
    console.log('Enforcing uppercase on input:', input);

    if (!input || input.dataset.uppercaseEnforced === 'true') return;
    
    input.dataset.uppercaseEnforced = 'true';
    
    input.addEventListener('input', (event) => {
      const start = input.selectionStart;
      const end = input.selectionEnd;
      input.value = input.value.toUpperCase();
      input.setSelectionRange(start, end);
    });

    input.addEventListener('blur', () => {
      input.value = input.value.toUpperCase();
    });
  };

  const setupNipInputs = () => {
    const nipInput = findNipInput();
    if (nipInput) {
      enforceUppercaseOnInput(nipInput);
    }
  };

  const checkIfExistNip = () => {
    const form = document.querySelector('#bss-b2b-register-form');
    
    if (!form) {
      return;
    }

    // Prevent multiple event listeners
    if (form.dataset.nipValidationInit === 'true') {
      return;
    }
    form.dataset.nipValidationInit = 'true';

    const validateNip = async () => {
      const nipInput = findNipInput();

      // No NIP input found, allow submission
      if (!nipInput) {
        return true;
      }

      const errorMessage = nipInput.closest('.bss-b2b-rf-field')?.querySelector('.bss-message');
      const nipValue = nipInput.value.trim();

      // Empty NIP, allow submission
      if (!nipValue) {
        if (errorMessage) {
          errorMessage.textContent = "";
          errorMessage.style.color = '';
        }
        return true;
      }

      const isAssigned = await isAssignedNip(nipValue);

      if (isAssigned) {
        if (errorMessage) {
          errorMessage.textContent = window.Eurus.nip_error_message || "Invalid NIP number.";
          errorMessage.style.color = 'rgb(255, 0, 0)';
        }

        if (nipInput.dataset.nipErrorListener !== 'true') {
          nipInput.dataset.nipErrorListener = 'true';
          nipInput.addEventListener('input', () => {
            if (errorMessage) {
              errorMessage.textContent = "";
              errorMessage.style.color = '';
            }
          });
        }

        nipInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        nipInput.focus({ preventScroll: true });
        return false;
      }

      if (errorMessage) {
        errorMessage.textContent = "";
        errorMessage.style.color = '';
      }

      return true;
    };

    const runValidatedSubmit = async () => {
      const canSubmit = await validateNip();
      if (!canSubmit) {
        return;
      }

      form.dataset.nipValidated = 'true';
      const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
      if (submitButton) {
        submitButton.click();
      } else {
        form.requestSubmit();
      }
    };

    form.addEventListener('submit', (event) => {
      if (form.dataset.nipValidated === 'true') {
        form.dataset.nipValidated = 'false';
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      runValidatedSubmit();
    }, { capture: true });
  };

  const lockCountryInput = () => {
    const countryField = document.querySelector('.bss-b2b-rf-field.field-country');
    if (!countryField || countryField.dataset.countryLockInit === 'true') {
      return;
    }

    const countryInput = countryField.querySelector('input.country-name, #country-name');
    const countryHidden = countryField.querySelector('input[type="hidden"]#country-field');
    const countryList = countryField.querySelector('#country-list');

    if (!countryInput || !countryHidden || !countryList) {
      return;
    }

    countryField.dataset.countryLockInit = 'true';

    const applyDisplayFromValue = (value) => {
      const match = countryList.querySelector(`li[value="${value}"]`);
      if (match) {
        countryInput.value = match.textContent.trim();
      }
    };

    // Prevent free typing; keep built-in list selection logic intact.
    countryInput.readOnly = true;
    countryInput.setAttribute('aria-readonly', 'true');
    countryInput.setAttribute('inputmode', 'none');
    countryInput.setAttribute('autocomplete', 'off');

    const showAllCountries = () => {
      const allItems = countryList.querySelectorAll('li');
      allItems.forEach(item => {
        item.style.display = 'block';
      });
    };

    ['keydown', 'keypress', 'keyup', 'input', 'paste', 'drop'].forEach((eventName) => {
      countryInput.addEventListener(eventName, (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        showAllCountries();
      }, { capture: true });
    });

    countryInput.addEventListener('focus', () => {
      showAllCountries();
    });

    countryInput.addEventListener('click', () => {
      showAllCountries();
    });

    countryList.addEventListener('click', () => {
      setTimeout(() => {
        applyDisplayFromValue(countryHidden.value);
        countryHidden.dispatchEvent(new Event('change', { bubbles: true }));
        countryInput.dispatchEvent(new Event('input', { bubbles: true }));
        countryInput.dispatchEvent(new Event('change', { bubbles: true }));
        
        // Setup uppercase on new NIP input after country change
        setTimeout(() => {
          setupNipInputs();
        }, 200);
      }, 0);
    });

    countryHidden.addEventListener('change', () => {
      applyDisplayFromValue(countryHidden.value);
    });
  };

  const setInitialCountryFromMarket = () => {
    const countryField = document.querySelector('.bss-b2b-rf-field.field-country');
    if (!countryField) return;

    const countryInput = countryField.querySelector('input.country-name, #country-name');
    const countryHidden = countryField.querySelector('input[type="hidden"]#country-field');
    const countryList = countryField.querySelector('#country-list');

    if (!countryInput || !countryHidden || !countryList) return;

    const marketCountryCode = window.Eurus?.market_country_code;
    
    if (marketCountryCode) {
      const marketCountryItem = countryList.querySelector(`li[value="${marketCountryCode}"]`);
      if (marketCountryItem) {
        countryHidden.value = marketCountryCode;
        countryInput.value = marketCountryItem.textContent.trim();
        
        // Trigger events to activate BSS logic
        setTimeout(() => {
          countryHidden.dispatchEvent(new Event('change', { bubbles: true }));
          countryInput.dispatchEvent(new Event('input', { bubbles: true }));
          countryInput.dispatchEvent(new Event('change', { bubbles: true }));
          
          // Setup uppercase after BSS switches inputs
          setTimeout(() => {
            setupNipInputs();
          }, 200);
        }, 100);
      }
    } else {
      // No market country, setup inputs immediately
      setTimeout(() => {
        setupNipInputs();
      }, 200);
    }
  };

  function checkForm() {
    const form = document.querySelector('#bss-b2b-register-form');
    if (form) {
      console.log("Formularz BSS został wstrzyknięty 👌");
      lockCountryInput();
      setInitialCountryFromMarket();
      checkIfExistNip();
      observer.disconnect();
    }
  }

  const observer = new MutationObserver(checkForm);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  checkForm();
});